import * as actions from "./actions";
import initialState from "./initialState";

export default (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_CURRENCY:
            return {
                ...state,
                currency: action.payload,
            };
        default:
            return state;
    }
};
